import React from 'react';
import FormContacto from '../../components/forms/formContacto';

const EditContacto = () => {
    return (
        <FormContacto id={1}/>
    );
}
 
export default EditContacto;